import { parseEnvironment } from '../elements/environment';
import { parseFloor, postRenderFloor } from '../elements/floor';
import { parseObject, unsetLights } from '../elements/object';
import { parseGroup } from '../elements/group';
import { extractVariable } from '../../wtl-schema/helpers/extract-variable';
import { parseWall } from '../elements/wall';
import { parseTile } from '../elements/tile';
import { parseRoof } from '../elements/roof';

let waterTiles = [];

export const parseSchema = (branch, context, options = {}) => {
  if (!context.renderer || !context.root) {
    return;
  }

  if (!branch) {
    return null;
  }

  if (typeof branch === 'string') {
    return extractVariable(branch);
  }

  const {
    id,
    type,
    _dirty
  } = branch;
  const { root, resyncSelectionMesh, effects, selectionBranch, currentFloorIndex, renderWalls } = context;
  const key = [options.key, id].filter(Boolean).join('-');

  const isHiddenFloor = type === 'floor' && ((renderWalls === 1 && currentFloorIndex < branch.yOffset) || (renderWalls === 0 && currentFloorIndex !== branch.yOffset));
  const isActiveFloor = type === 'floor' && (context.currentFloorIndex === branch.yOffset);

  const childrenOptions = {
    key: key,
    parentId: id,
    parent: root,
    isOnActiveFloor: type === 'floor' ? isActiveFloor : null
  };

  if (branch instanceof Array) {
    return branch.map((subbranch, index) => parseSchema(subbranch, context, childrenOptions));
  }

  let objectOrGroup;
  const richOptions = {
    ...options,
    _selfKey: key
  };

  let cacheExistingChildren;
  if (_dirty === 2) {
    const existingInstance = root.getObjectByName(key);

    if (existingInstance) {
      if (existingInstance.parent) {
        cacheExistingChildren = existingInstance.children;

        existingInstance.parent.remove(existingInstance);
      }
    }
  }

  switch (type) {
    case 'environment':
      unsetLights();
      objectOrGroup = parseEnvironment(branch, context, richOptions);
    break;
    case 'floor':
      waterTiles = [];
      objectOrGroup = parseFloor(branch, context, richOptions);
    break;
    case 'group':
      objectOrGroup = parseGroup(branch, context, richOptions);
    break;
    case 'wall':
      objectOrGroup = parseWall(branch, context, richOptions);
    break;
    case 'roof':
      objectOrGroup = parseRoof(branch, context, richOptions);
    break;
    case 'tile':
      if (branch.material === 'water') {
        waterTiles.push(branch);
      }

      objectOrGroup = parseTile(branch, context, richOptions);
    break;
    case 'object':
      objectOrGroup = parseObject(branch, context, { ...richOptions, selectable: true, selectionTarget: true });
    break;
  }

  if (objectOrGroup) {
    objectOrGroup.name = key;
    objectOrGroup.branchId = id;
    childrenOptions.parent = objectOrGroup;

    if (branch === selectionBranch && effects.drag && !branch._locked) {
      effects.drag.detach();
      effects.drag.attach(objectOrGroup);
      resyncSelectionMesh(objectOrGroup);
    }
  }

  let result;

  if (!isHiddenFloor && branch.content && branch.content instanceof Array) {
    result = branch.content.map((subbranch, index) => parseSchema(subbranch, context, childrenOptions));
  }

  switch (type) {
    case 'floor':
      postRenderFloor(objectOrGroup, branch, context, {
        waterTiles
      });
    break;
  }

  if (_dirty === 2) {
    branch._dirty = 1;
  } else {
    branch._dirty = 0;
  }

  return result;
};
